import RestAPI from '../../../components/Common/restApi';

export default class QuickbooksOnlineCompanyApi {
  static show() {
    return RestAPI.getWithQueryString('/alpha/quickbooks_online/company');
  }
}
